"use client";

import {
  HelpCircle,
  House,
} from "lucide-react";
import React from "react";
import { useRouter, usePathname } from "next/navigation";
import { motion } from "framer-motion";

export default function MenuBar() {
  const router = useRouter();
  const pathname = usePathname();

  const links = [
    { label: "Inicio", icon: House, path: "/" },
    { label: "FAQ", icon: HelpCircle, path: "/faq" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-150 pb-safe">
      <div className="max-w-md w-full mx-auto flex items-center justify-around py-2 px-4">
        {links.map(({ label, icon: Icon, path }) => {
          const isActive = pathname === path;

          return (
            <motion.div
              key={label}
              whileTap={{ scale: 0.95 }}
              className={`flex flex-col items-center gap-1 cursor-pointer transition-all min-w-[60px] py-2 px-3 rounded-xl ${
                isActive 
                  ? "bg-blue-50" 
                  : "hover:bg-gray-50"
              }`}
              onClick={() => {
                if (path === "/") {
                  window.location.href = path;
                } else {
                  router.push(path);
                }
              }}
            >
              <div className={`transition-all ${
                isActive 
                  ? "bg-gradient-to-br from-blue-500 to-blue-600 p-2 rounded-xl shadow-lg shadow-blue-500/30" 
                  : "p-2"
              }`}>
                <Icon className={`w-5 h-5 transition-colors ${
                  isActive 
                    ? "text-white" 
                    : "text-gray-400"
                }`} />
              </div>
              <span className={`text-xs font-medium transition-colors ${
                isActive 
                  ? "text-blue-600" 
                  : "text-gray-400"
              }`}>
                {label}
              </span>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
